import { useToast } from '@chakra-ui/react';
import {
  CompositionMaterial,
  CreateCompositionMaterialRequest,
  compositionApi,
} from '@texas/api/endpoints/compositionApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { ServerError } from '@texas/types';
import { request } from '@texas/utils/helpers/httpHelpers';
import { useTranslation } from 'react-i18next';
import {
  CompositionMaterialForm,
  MaterialFormType,
} from './CompositionMaterialForm';

interface CreateCompositionProps extends SharedDisclosureProps {
  compositionId: number;
  productGroupId: number | null;
  subTitle?: string;
  onCreated: (data: CompositionMaterial) => void;
  formType?: MaterialFormType;
  isReady: boolean;
  groupHasAnyBasedOn: boolean;
  vdcTemplate: boolean;
}

export function CreateCompositionMaterial({
  compositionId,
  productGroupId,
  isOpen,
  onClose,
  onCreated,
  subTitle,
  formType,
  isReady,
  groupHasAnyBasedOn,
  vdcTemplate,
}: CreateCompositionProps) {
  const { request: createRequest } = useApiRequest(
    compositionApi.createCompositionMaterial,
  );

  const toast = useToast();
  const { t } = useTranslation();

  const onSubmit = async (data: CreateCompositionMaterialRequest) =>
    await request(
      createRequest,
      [compositionId, data],
      (response) => {
        onCreated(response);
        toast({
          title: t('general.created'),
          status: 'success',
          isClosable: true,
        });
      },
      (error: ServerError) => {
        toast({
          title: t('general.createFailed'),
          description: error.message,
          status: 'error',
          isClosable: true,
        });
      },
    );

  return (
    <CompositionMaterialForm
      formType={formType}
      loading={false}
      onClose={onClose}
      isOpen={isOpen}
      subTitle={subTitle}
      productGroupId={productGroupId}
      onFormSubmit={(data) => onSubmit(data)}
      isReady={isReady}
      groupHasAnyBasedOn={groupHasAnyBasedOn}
      vdcTemplate={vdcTemplate}
    />
  );
}
